export default __webpack_public_path__ + "static/media/java2.6c64373d.png";